import React, { createContext, useContext, useState } from 'react';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'admin';

const AdminContext = createContext();

function getStoredUnlock() {
  try {
    return typeof sessionStorage !== 'undefined' && sessionStorage.getItem('adminUnlocked') === '1';
  } catch (e) {
    return false;
  }
}

export function AdminProvider({ children }) {
  const [isUnlocked, setIsUnlocked] = useState(getStoredUnlock);

  const unlock = (password) => {
    if (password === ADMIN_PASSWORD) {
      setIsUnlocked(true);
      return true;
    }
    return false;
  };

  const lock = () => setIsUnlocked(false);

  return (
    <AdminContext.Provider value={{ isUnlocked, unlock, lock }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
}
